import { Box, Typography } from '@mui/material';
import { PageTitle } from '../../../components/StyledComponents';
import { HeaderContainer } from '../StyledComponents';

const Header = () => {
  return (
    <HeaderContainer>
      <Box>
        <PageTitle>Library</PageTitle>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', mt: 0.5 }}
        >
          Only approved projects, forms, and deliverables appear here.
        </Typography>
      </Box>
    </HeaderContainer>
  );
};

export { Header };
